module.exports = "/assets/data/f9b7def4b9a030468997ab11cf3a106f-BB11.data.json";